export default {
      id: "import_contacts-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#import_contacts",
      toString: function () {
        return this.url;
      }
    }